export const NEW_ERROR = "/errors/NEW-ERROR",
  DELETE_ERROR = "/errors/DELETE-ERRORS";
